import gql from 'graphql-tag';

export default gql`
  mutation createNewCustomer(
    $loginName: String!
    $password: String!
    $country: String!
    $firstName: String!
    $lastName: String!
    $captchaToken: String
    $memberSourceAndDeviceType: String
    $googleReCaptchaToken: String
    $action: String
  ) {
    createNewCustomer(
      loginName: $loginName
      password: $password
      country: $country
      firstName: $firstName
      lastName: $lastName
      captchaToken: $captchaToken
      memberSourceAndDeviceType: $memberSourceAndDeviceType
      googleReCaptchaToken: $googleReCaptchaToken
      action: $action
    ) {
      loginStatus
      errors {
        propertyName
        message
      }
    }
  }
`;
